<div>
  <div *ngIf="SeoContent?.PageContent" class="SeoDynamicPageContent" [ngClass]="{'showTowLines': !ShowItem}"
    [innerHTML]="SeoContent?.PageContent">
  </div>
  <span class="expander" *ngIf="SeoContent?.PageContent" (click)="ReadMoreLess()">
    <i class="fas" [ngClass]="{'fa-chevron-down': !ShowItem, 'fa-chevron-up': ShowItem}"></i>
  </span>
</div>
